module.exports = __webpack_public_path__ + "img/api_key_generate.c40a8881.png";